import axiosInstance from '../../services/axiosInstance';
import { BillingSubscription } from '../../types/subscription';

export const getSubscriptions = async (skip = 0, limit = 10) => {
    try {
        const response = await axiosInstance.get('/service-subscriptions', {
            params: {
                skip,
                limit
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAllSubscriptions = async () => {
    try {
        const allSubscriptions: any[] = [];
        let skip = 0;
        const limit = 500;
        let hasMore = true;

        while (hasMore) {
            const response = await getSubscriptions(skip, limit);

            if (response.length === 0) {
                hasMore = false;
            } else {
                allSubscriptions.push(...response);
                skip += limit;
            }
        }

        return allSubscriptions;
    } catch (error) {
        throw error;
    }
};

export const getServiceSubscriptions = async (serviceName: string) => {
    try {
        const response = await axiosInstance.get('/service-subscriptions', {
            params: {
                service_name: serviceName,
                skip: 0,
                limit: 100
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export interface SubscriptionStats {
    totalRevenue: number;
    activeSubscribers: number;
    subscriptions: BillingSubscription[];
    recentSubscriptions: BillingSubscription[];
}

export const calculateSubscriptionStats = async () => {
    try {
        console.log("Calculating subscription stats...");
        const subscriptions = await getAllSubscriptions();

        console.log("Total subscriptions fetched:", subscriptions.length);

        const now = Date.now();
        const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000; // 30 days in ms
        console.log("Now:", new Date(now).toISOString());
        console.log("30 days ago:", new Date(thirtyDaysAgo).toISOString());

        const stats = subscriptions.reduce(
            (acc, subscription) => {
                // Optional: log each subscription's created_at
                console.log("Subscription ID:", subscription._id, "created_at:", subscription.created_at);

                // Accumulate revenue and active subscribers for all statuses
                const price = parseFloat(subscription.price.replace(/[^0-9.-]+/g, '')) || 0;
                acc.totalRevenue += price;

                if (!acc.activeSubscriberIds.has(subscription.userid)) {
                    acc.activeSubscriberIds.add(subscription.userid);
                }

                // Check if created within the past 30 days
                const createdTime = new Date(subscription.created_at).getTime();
                if (!isNaN(createdTime)) {
                    if (createdTime >= thirtyDaysAgo) {
                        acc.recentSubscriptions.push(subscription);
                        console.log("Added to recent:", subscription._id);
                    }
                } else {
                    console.warn("Invalid created_at for subscription:", subscription._id, subscription.created_at);
                }

                acc.subscriptions.push(subscription);
                return acc;
            },
            {
                totalRevenue: 0,
                activeSubscriberIds: new Set<string>(),
                subscriptions: [] as typeof subscriptions,
                recentSubscriptions: [] as typeof subscriptions
            }
        );

        console.log("Final recentSubscriptions count:", stats.recentSubscriptions.length);

        return {
            totalRevenue: stats.totalRevenue,
            activeSubscribers: stats.activeSubscriberIds.size,
            subscriptions: stats.subscriptions,
            recentSubscriptions: stats.recentSubscriptions
        };
    } catch (error) {
        console.error("Error in calculateSubscriptionStats:", error);
        throw error;
    }
};

